module.exports = __webpack_public_path__ + "img/adan_ligegfr.2afacd3b.webp";